import { FC } from 'react';
import { css } from '../../../utils/css';
import { Table, TableParams } from './table';
import styles from './scrollTable.module.css';

export const ScrollTable: FC<TableParams> = ({className = false, ...props}) => {
    return <Table className={css(styles.ScrollTable, className)} {...props} />
}